import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Text, View, TouchableOpacity, Image, ActivityIndicator } from 'react-native';

import { Icon } from '../../components';
import Theme from '../../theme';
import { setPartnerProfiles, fetchPartnerProfiles } from '../actions';
import { styles } from './Styles';
import InviteDescriptionWithPartnerNames from './InviteDescriptionWithPartnerNames';
import { haveInvitesChanged } from '../utils/BookingUtils';
import { InvitesIcon } from '../../ui/components/Icons';

class InvitesCard extends Component {
  componentDidUpdate = async (prevProps) => {
    if (haveInvitesChanged(prevProps.invites,  this.props.invites)) {
      const { userProfileService: { getUserProfileDetails }, fetchPartnerProfiles } = this.props;
      await fetchPartnerProfiles(this.props.invites, getUserProfileDetails);
    }
  }

  componentDidMount = async () => {
    const { userProfileService: { getUserProfileDetails }, fetchPartnerProfiles } = this.props;
    await fetchPartnerProfiles(this.props.invites, getUserProfileDetails);
  }

  getCardDescriptionWithPartners = () => {
    const { partnerProfiles } = this.props;
    const firstnames = Object.keys(partnerProfiles).map((key) => partnerProfiles[key].firstname);
    return (
      <InviteDescriptionWithPartnerNames firstnames={firstnames} />
    );
  }

  render() {
    const { t, invites, viewInvites, isLoading } = this.props;

    if (invites.length === 0) {
      return null;
    }

    return (
      <TouchableOpacity
        disabled={isLoading}
        onPress={viewInvites}
        style={styles.cardContainer}>
        <View style={styles.cardInfoSection}>
          <View style={styles.cardHeader}>
            <View style={styles.iconContainer}>
              <InvitesIcon color={Theme.CHARCOAL} width={30} height={30} />
            </View>
            <View style={styles.headerContainer}>
              <Text style={styles.title}>{t('invite', { count: invites.length })}</Text>
              <Text style={styles.subtitle}>{t('toTrainWithPartner')}</Text>
            </View>
          </View>
          {isLoading ?
            <ActivityIndicator
              size='small'
              color={Theme.PRIMARY}
              animating={isLoading}
            />
            :
            <View>
              {this.getCardDescriptionWithPartners()}
            </View>
          }
        </View>
        <View style={styles.arrowContainer}>
          <Icon
            size={25}
            color={Theme.WHITE}
            name="ios-arrow-forward"
          />
        </View>
      </TouchableOpacity>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    invites: state.bookings.bookingWizard.invites,
    workoutSession: state.bookings.bookingWizard.workoutSession,
    isLoading: state.bookings.bookingWizard.isFetchingPartnerProfiles,
    partnerProfiles: state.bookings.bookingWizard.partnerProfiles,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    setPartnerProfiles: (partnerProfiles) => dispatch(setPartnerProfiles(partnerProfiles)),
    fetchPartnerProfiles: (invites, getUserProfileDetails) => dispatch(fetchPartnerProfiles(invites, getUserProfileDetails)),
  };
};

InvitesCard = connect(mapStateToProps, mapDispatchToProps)(InvitesCard);
export default translate(['bookings'], { wait: true })(InvitesCard);
